import React, { useState, useEffect, useCallback, Fragment } from 'react';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import moment from 'moment';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import * as _ from 'lodash';
import EmptyState from '../../images/icons/CommisionIcons/EmptyState.svg';
import CustomMaterialPagination from '../../components/Table/customPagination';
import styles from './Style.module.css';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import TableSearchBox from '../../components/CommonMbTableCard/MBTableSearchBox';
import PopUp from '../../common/components/PopUp/PopUp';
import backBtn_icon from '../../images/icons/backBtn_icon.svg';
import callCompelete from '../../images/icons/CallLogsIcons/callCompelete.svg';
import clientHangUp from '../../images/icons/CallLogsIcons/clientHangUp.svg';
import incomingCall from '../../images/icons/CallLogsIcons/incomingCall.svg';
import outgoingCall from '../../images/icons/CallLogsIcons/outgoingCall.svg';
import { navigate } from 'gatsby';
import { getCallLogsAPI } from '../../common/constants/api';
import { DateFormat } from '../../components/Table/RMColumnData';
import CustomAudio from './CustomAudio';
import {
  faPhoneVolume,
  faPhoneSlash,
  faAngleDoubleRight
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterListIcon from '@material-ui/icons/FilterList';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import PopupFilter from '../../common/components/PopupFilter/PopupFilter';
import CallMade from '../../common/components/PopupFilter/FilterComponents/CallMade';
import RM from '../../common/components/PopupFilter/FilterComponents/RmList';
import CallType from '../../common/components/PopupFilter/FilterComponents/CallType';
import rmICon from '../../images/icons/PopUpFilter/rmImg.svg';
import callType from '../../images/icons/PopUpFilter/callType.svg';
import SvgComponent from '../../common/components/SvgComponent/SvgComponent';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import MBTableSearchBox from '../../components/CommonMbTableCard/MBTableSearchBox';

const CallLog = props => {
  const { tableStyle } = styles;

  const dashboardRedirect = () => {
    typeof history !== 'undefined' && history.go(-1);
  };
  const [tableData, setTableData] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState('50');
  const [rows, setRows] = useState('10');
  const [page, setPage] = useState('0');
  const [searchbar, setSearchBar] = useState('');
  const [callApiForSeachField, setCallApiForSearchField] = useState(null);

  const [showFilter, setShowFilter] = useState(false);
  const [firstLoading, setFirstLoading] = useState(true);

  const [selectedFields, setHtmlSelectedFileds] = useState({});
  const [updatedFilters, setUpdatedFilters] = useState(
    getFiltersInfo()?.callLogs || {}
  );
  const [masterFilters, setMasterFilters] = useState(
    getFiltersInfo()?.callLogs
  );

  const handlePageChange = pageNumber => {
    setPage(pageNumber - 1);
  };
  const handlePerRowsChange = (rows, pageNumber) => {
    setRows(rows);
    setPage(0);
  };

  const getCallType = () => {
    try {
      let keys = Object.keys(updatedFilters?.callType || {});
      let statusOk = keys?.filter(
        each => updatedFilters?.callType?.[each]?.status
      );
      return statusOk?.toString();
    } catch {
      return '';
    }
  };
  const getRM = () => {
    try {
      let keys = Object.keys(updatedFilters?.rm || {});
      let statusOk = keys?.filter(
        each => updatedFilters?.rm?.[each]?.status && each != 'undefined'
      );
      return statusOk?.toString();
    } catch {
      return '';
    }
  };

  const getCallLog = () => {
    setType('loading');
    setText('Please wait while retrieving data...');
    setShow(true);
    let fromDate =
      updatedFilters?.fromDate || updatedFilters?.callMade?.startDate;
    let toDate = updatedFilters?.toDate || updatedFilters?.callMade?.toDate;
    let callType =
      typeof updatedFilters?.callType == 'string'
        ? updatedFilters?.callType
        : getCallType();
    let rm =
      typeof updatedFilters?.rm == 'string' && updatedFilters?.rm != 'undefined'
        ? updatedFilters?.rm
        : getRM();

    getCallLogsAPI({
      leadId: props.leadId || '',
      page: page,
      rows: rows,
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
      toDate: moment(toDate).format('YYYY-MM-DD'),
      callType: callType,
      rm: rm,
      searchby: searchbar
    })
      .then(res => {
        setTableData(res._embedded?.leadCallLogsDtoList);
        setShow(false);
        if (callApiForSeachField == null) setCallApiForSearchField(false);
        setRowsPerPage(res?.page);
        setFirstLoading(false);
      })
      .catch(error => {
        setShow(false);
      });
  };
  useEffect(() => {
    getCallLog();
  }, []);

  useEffect(() => {
    if (!firstLoading) getCallLog();
  }, [page, rows, updatedFilters, callApiForSeachField]);

  const appledFilters = filter => {
    let callType = Object.keys(filter?.callType || {})?.filter(
      each => filter?.callType[each]
    );
    let rm = Object.keys(filter?.rm || {})?.filter(
      each => filter?.rm[each]?.status
    );
    setUpdatedFilters({
      fromDate: filter?.callMade?.startDate,
      toDate: filter?.callMade?.toDate,
      callType: callType?.[0] || '',
      rm: rm?.[0] || ''
    });
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      callLogs: filter
    });
  };

  const commonUpperStyle = { maxHeight: '20px', maxWidth: '20px' };
  const rmImg = ({ className, style }) => (
    <SvgComponent
      img={rmICon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );
  const callTypeImg = ({ className, style }) => (
    <SvgComponent
      img={callType}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );

  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Call Made on',
      name: 'date',
      component: CallMade
    },
    {
      img: callTypeImg,
      title: 'Call Type',
      name: 'callType',
      component: CallType
    },
    {
      img: rmImg,
      title: 'RM',
      name: 'rm',
      component: RM
    }
  ];

  const setSeachFieldByDebounce = useCallback(
    callApiForSeachField != null
      ? _.debounce(function() {
          setCallApiForSearchField(!callApiForSeachField);
        }, 800)
      : function() {},

    [callApiForSeachField]
  );

  return (
    <React.Fragment>
      <Helmet title={`Call Logs | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1 w-full">
            <div className="flex items-center">
              <div className="w-full flex items-center text-black-400 text-md ml-4 font-bold mt-4 mb-4 mb-0 relative">
                <span
                  className="mr-1 cursor-pointer"
                  onClick={dashboardRedirect}
                >
                  <img src={backBtn_icon} alt="back" />
                </span>
                <FontAwesomeIcon icon={faAngleDoubleRight} className="mr-1" />

                <span className="text-base">Call Logs</span>
              </div>
              <Header />
            </div>

            <div
              className="bg-white rounded-md py-4 mx-6"
              style={{
                minHeight: '40%',
                boxShadow: '0px 3px 16px #0A4B6D29'
              }}
            >
              <div className="w-full bg-white py-4 px-5 rounded-xl shadow ">
                <div className="w-full xl:flex block xl:flex-wrap ">
                  <div
                    className="cursor-pointer py-1 ml-4"
                    style={{ width: '150px' }}
                    onClick={() => setShowFilter(true)}
                  >
                    <div className="border border-grey-2235 rounded flex py-2 px-4">
                      <p className="text-grey-2236 font-roboto font-normal text-sm">
                        Filter
                      </p>
                      <div className="table ml-auto ">
                        <FilterListIcon style={{ color: '#8a939e' }} />
                      </div>
                    </div>
                  </div>
                  <div
                    className="w-full xl:max-w-sm xl:ml-auto align-center pl-4"
                    style={{ marginTop: '0.3rem' }}
                  >
                    <MBTableSearchBox
                      containerStyle={{ width: '100%' }}
                      searchbar={searchbar}
                      setSearchBar={e => {
                        setPage(0);
                        setSearchBar(e);
                        setSeachFieldByDebounce(e);
                      }}
                      onEnter={getCallLog}
                    />
                  </div>
                </div>
                <div className="w-full flex flex-wrap">
                  {Object.keys(selectedFields || {}).map(each =>
                    searchbar?.length > 0 && each == 'callMade' ? (
                      <Fragment />
                    ) : (
                      selectedFields[each]
                    )
                  )}
                </div>
              </div>

              <div className=" mx-4 relative m-auto overflow-auto">
                {(!tableData || (tableData && tableData?.length == 0)) && (
                  <div
                    className="flex flex-col items-center justify-center"
                    style={{
                      minHeight: '400px'
                    }}
                  >
                    <img src={EmptyState} alt="" />
                    <p className="text-grey-2231 mt-4">No Call Logs Yet</p>
                  </div>
                )}

                {tableData?.length > 0 && (
                  <table className={`w-full  ${tableStyle}`}>
                    <thead>
                      <tr className="text-sm">
                        <th className={`px-4 py-4 `}>Lead Id</th>
                        <th className=" px-4 py-4">Applicant</th>
                        <th className=" px-2 py-4">Call Attempt</th>
                        <th className=" px-2 py-4">Call Direction</th>
                        <th className=" px-2 py-2">Call Type</th>
                        <th className=" px-2 py-2 pl-10">Duration</th>
                        <th className=" px-4 py-2">RM name</th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {tableData &&
                        tableData.map((each, index) => {
                          const {
                            callCompletedStatus,
                            callStartedAt,
                            isCallOutgoing,
                            recordingUrl,
                            leadId
                          } = each;
                          let fullName = `${each?.applicantName?.firstName ||
                            ''} ${each?.applicantName?.middleName || ''} ${each
                            ?.applicantName?.lastName || ''}`;
                          let fullRMName = `${each?.rmName?.firstName ||
                            ''} ${each?.rmName?.middleName || ''} ${each?.rmName
                            ?.lastName || ''}`;
                          let callTypeIcon =
                            callCompletedStatus === 'completed'
                              ? callCompelete
                              : callCompletedStatus === 'failed'
                              ? clientHangUp
                              : '';
                          return (
                            <tr
                              key={index}
                              className="hover:bg-grey-1004 font-roboto font-normal text-xs text-black-850"
                            >
                              <td className={`px-4 py-4 `}>{leadId}</td>
                              <td className="px-4 py-4">{fullName || ''}</td>
                              <td className="px-2 py-4">
                                {DateFormat(callStartedAt)}
                                <p>
                                  {callStartedAt &&
                                    moment(callStartedAt).format('hh:mm A')}
                                </p>
                              </td>
                              <td className="px-2 py-4">
                                <div className="flex">
                                  <img
                                    src={
                                      isCallOutgoing
                                        ? outgoingCall
                                        : incomingCall
                                    }
                                    alt=""
                                    className="mr-2"
                                  />
                                  {isCallOutgoing ? 'Outgoing' : 'Incoming'}
                                </div>
                              </td>
                              <td className="px-2 py-4">
                                <div className="flex items-center">
                                  {callCompletedStatus !== 'busy' &&
                                    callCompletedStatus !== 'no-answer' &&
                                    callCompletedStatus !== 'canceled' && (
                                      <img
                                        src={callTypeIcon}
                                        alt=""
                                        className="mr-2"
                                      />
                                    )}

                                  {callCompletedStatus === 'canceled' && (
                                    <CallMissedOutgoingIcon
                                      style={{
                                        color: 'red',
                                        marginRight: '8px'
                                      }}
                                    />
                                  )}

                                  {callCompletedStatus === 'busy' && (
                                    <FontAwesomeIcon
                                      icon={faPhoneVolume}
                                      style={{
                                        color: 'green',
                                        marginRight: '8px'
                                      }}
                                    />
                                  )}
                                  {callCompletedStatus === 'no-answer' && (
                                    <FontAwesomeIcon
                                      icon={faPhoneSlash}
                                      style={{
                                        color: 'red',
                                        marginRight: '8px'
                                      }}
                                    />
                                  )}

                                  {callCompletedStatus
                                    ? callCompletedStatus
                                    : '-'}
                                </div>
                              </td>
                              <td className="px-2 py-4">
                                <div className="flex">
                                  <CustomAudio recordingUrl={recordingUrl} />
                                </div>
                              </td>
                              <td className="px-4 py-4">{fullRMName || ''}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
            <div
              style={{
                background: '#f6f6f6',
                left: '0px',
                right: '0px'
              }}
            >
              <CustomMaterialPagination
                handlePageChange={handlePageChange}
                handlePerRowsChange={handlePerRowsChange}
                setRowsPerPage={setRowsPerPage}
                setPage={setPage}
                page={page}
                pageInfo={rowsPerPage}
                setRows={setRows}
                Rows={rows}
              />
            </div>
          </div>
        </div>
        <PopupFilter
          show={showFilter}
          setShow={setShowFilter}
          dataList={dataList}
          handleApply={appledFilters}
          handleToastBlock={e => setHtmlSelectedFileds(e)}
          masterFiltersData={masterFilters}
        />
      </div>
      <PopUp type={type} text={text} show={show} setShow={setShow} />
    </React.Fragment>
  );
};

export default withErrorHandler(CallLog);
